import BaseView from '@/core/view/BaseView'

/**
 * ヘッダー
 */
class HeaderView extends BaseView {
  //

  // ミニヘッダー状態かどうか
  private isMinHeader = false

  //
  private body!: HTMLElement

  /**
   * コンストラクタ
   *
   */
  constructor() {
    super()

    // ヘッダー
    this.body = document.getElementsByTagName('body')![0]

    //
    this.listenResize()
    this.listenScroll()
  }

  /**
   * 大にする
   */
  private clearShort() {
    if (this.body!.classList.contains('short-header')) {
      this.body.classList.remove('short-header')
    }
    this.isMinHeader = false
  }

  /**
   * 小にする
   */
  private setShort() {
    this.body!.classList.add('short-header')
    this.isMinHeader = true
  }

  /**
   * リサイズイベントハンドラ
   *
   */
  public onResize(): void {
    // do nothing.
  }

  /**
   * 破壊
   */
  public dispose(): void {
    this.clearShort()
    this.unListenResize()
    this.unListenScroll()
  }

  /**
   * スクロールイベントハンドラ
   */
  onScroll(): void {
    // スクロール位置
    const scrollY = this.getScrollPositionY()

    // ヘッダーのminimize処理
    if (this.scrollDirection === 'up' && this.isMinHeader) {
      this.clearShort()
    } else if (scrollY <= 0 && this.isMinHeader) {
      this.clearShort()
    } else if (
      this.scrollDirection === 'down' &&
      scrollY > 0 &&
      !this.isMinHeader
    ) {
      this.setShort()
    }
  }
}

export default HeaderView
